import { render, staticRenderFns } from "./MyProjectsSection.vue?vue&type=template&id=0055c1bd&scoped=true"
import script from "./MyProjectsSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyProjectsSection.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MyProjectsSection.vue?vue&type=style&index=0&id=0055c1bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0055c1bd",
  null
  
)

export default component.exports